import React from 'react';
import { Icon, Accordion } from 'semantic-ui-react';
import { NavLink } from '../../../../../lib/components/link';
import classes from './sidebar.css';
import { MenuItemType, MenuItemLabelType } from '../../../../../lib/proptypes/menu.proptypes';
import { TEAMS_NAV_KEY } from '../../../../../store/actions/nav.types';

const AccordionDropDown = () => (
  <span className={classes.accordionToggleButton} >
    <Icon fitted name="angle down" className={classes.angleDown} />
  </span>
);

const AccordionTitles = ({ children, key, ...props }) => (
  <Accordion.Title
    className={classes.accordianTitleStyle}
    key={key}
  >
    {key === TEAMS_NAV_KEY || (children && children.length) ?
      <span className={classes.titleContainer}>
        <NavLink
          {...props}
          className={classes.titleLink}
          onClick={e => { e.stopPropagation(); }}
        />
        <AccordionDropDown />
      </span>
      : <NavLink {...props} className={classes.titleLink} />
    }
  </Accordion.Title>
);

AccordionTitles.propTypes = MenuItemType;

export default AccordionTitles;



// WEBPACK FOOTER //
// ./src/app/components/Nav/MobileNav/Sidebar/NavAccordionTitles.js